<template>
  <BaseDialogCard
    :onPrimaryButtonPressed="onPrimaryButtonPressed"
    :onCancelButtonPressed="onCancelButtonPressed"
    title="Push Voyage Calculation"
    primaryButtonText="Confirm"
    :dialogModel="dialog"
    :mainButtonDisabled="calculationDisabled"
  >
    <template #activatorButton="{ on, attrs }">
      <CustomThemedButton
        class="main-button"
        :loading="calculationLoading"
        rounded
        block
        @click="dialog = true"
        v-bind="attrs"
        v-on="on"
      >
        Calculate
      </CustomThemedButton>
    </template>
    <template #icon>
      <v-icon class="mr-1" color="primary">mdi-calculator</v-icon>
    </template>
    <template #content>
      <v-col class="mt-1 pa-0">
        <p v-if="!calculationDisabled" class="text-style">
          You are about to initiate a voyage calculation:
        </p>
        <p class="text-truncate text-subtitle-2" v-if="!calculationDisabled">
          {{ voyageDescription }}
        </p>
        <p v-if="!validForm" class="warning-style">
          You need to fill all relevant fields to initiate a voyage calculation
        </p>
        <p v-if="showComputationWarning" class="warning-style">
          {{ warningMessage }}
        </p>
        <p v-if="!calculationDisabled" class="text-style">
          Are you sure you want to proceed?
        </p>
      </v-col>
    </template>
  </BaseDialogCard>
</template>

  <script>
import { mapState, mapGetters, mapActions } from "vuex";
import BaseDialogCard from "../../../components/BaseDialogCard.vue";
import CustomThemedButton from "@/core/CustomThemedButton.vue";
export default {
  name: "CreateVoyageButton",
  components: {
    BaseDialogCard,
    CustomThemedButton,
  },
  props: {
    validForm : Boolean
    //validateForm: Function,
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters("weatherRouting/formModule", ["calculationFailed"]),
    ...mapGetters("weatherRouting", [
      "showComputationWarning",
      "noTokensRemaining",
    ]),
    ...mapState("weatherRouting", ["vesselParticulars"]),
    ...mapState("weatherRouting/formModule", [
      "calculationState",
      "calculationLoading",
      "currentTab",
      "calculationError",
      "voyageDescription",
    ]),
    calculationDisabled() {
      return this.vesselParticulars == null || this.noTokensRemaining || !this.validForm;
    },
    warningMessage() {
      if (this.vesselParticulars == null) {
        return "There seems to be an issue when fetching vessel particulars. Please try refreshing the page. If the issue persists, please contact support.";
      }
      if (this.noTokensRemaining) {
        return "Warning : You have used all of your computation tokens.Contact us for renewal";
      }
      return "Warning : You have used 90% of your total computation tokens";
    },
  },
  methods: {
    ...mapActions("weatherRouting/voyagesModule", ["fetchAllVoyages"]),
    async onPrimaryButtonPressed() {
      this.dialog = false;
      await this._submitCalculation();
    },
    onCancelButtonPressed() {
      this.dialog = false;
    },
    async _submitCalculation() {
  if (this.validForm) {
    await this._initiateVoyageCalculation();
    this.fetchAllVoyages();
  }
}
,
    async _initiateVoyageCalculation() {
      await this.$store.dispatch(
        "weatherRouting/formModule/pushVoyageCalculation",
        {
          callback: async (voyageId) => {
            this._goToVoyageDetails(voyageId);
            await this._refreshCompanyData();
          },
        }
      );
    },
    async _refreshCompanyData() {
      await this.$store.dispatch("weatherRouting/fetchCompany");
    },
    _goToVoyageDetails(voyageId) {
      this.$router.push({
        name: "Voyage Details",
        params: {
          vessel: this.$route.params.vessel,
          voyageId: voyageId,
        },
      });
    },
  },
};
</script>

<style>
.warning-style {
  color: red;
  font-size: 14px;
  line-height: 1.5;
}
.main-button {
  background-color: var(--color-secondary) !important;
  color: var(--color-text) !important;
}

.text-style {
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text);
}
</style>
